import { ReferenceInput, SelectInput } from "react-admin";
import * as React from "react";
import { SourceVwUser } from "../../../Constants/Source";

const UpdatedByInput = props => {
  return (
    <ReferenceInput source="updatedBy" reference={SourceVwUser} link={false} label="CREATED BY" {...props}>
      <SelectInput optionText="name" optionValue="registerId" />
    </ReferenceInput>
  );
};

export default UpdatedByInput;
